import { 
    apiGetFinancialBill,
    } from "@/apis/api.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_financial_bill_list: 'financiaBill/set_financial_bill_list',
    set_mode: 'financiaBill/set_mode',
    set_filter_query: 'financiaBill/set_filter_query',
    set_filter_word: 'financiaBill/set_filter_word',
    set_filter_result_total: 'financiaBill/set_filter_result_total',
    set_filter_default: 'financiaBill/set_filter_default',
    set_loading: 'financiaBill/set_loading'

}

// count state 必須是 Object
const state = {
    financialBillList: [],
    filterQuery: {
        county: '',
        countyId: '',
        district: '',
        amount: [0, 100000],
        notify: null,
    },
    filterTotal: {
        all: 0,
        overdue: 0,
        paid: 0,
        unpaid: 0,
    },
    filterWord: '',
    filterResultTotal: '',
    mode: null,
    isDefault: true,
    isLoading: false
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_FINANCIAL_BILL_MGT_LIST: (state) => {
        return state.financialBillList
    },
    GET_FINANCIAL_BILL_MGT_MODE: (state) => {
        return state.mode
    },
    GET_FINANCIAL_BILL_MGT_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_FINANCIAL_BILL_MGT_FILTER_WORD: (state) => {
        return state.filterWord
    },
    GET_FINANCIAL_BILL_MGT_FILTER_RESULT_TOTAL: (state) => {
        return state.filterTotal
    },
    GET_FINANCIAL_BILL_MGT_FILTER_COUNTY_IS_EMPTY: (state) => {
        if( state.filterQuery.county == '' ){
            return true
        }else{
            return false
        }
    },
    GET_FINANCIAL_BILL_MGT_FILTER_DISTRICT_IS_EMPTY: (state) => {
        if( state.filterQuery.district == '' ){
            return true
        }else{
            return false
        }
    },
    GET_FINANCIAL_BILL_FILTER_WORD_IS_EMPTY: (state) => {
        if( state.filterWord == '' ){
            return true
        }else{
            return false
        }
    },
    GET_FINANCIAL_BILL_MGT_FILTER_DEFAULT: (state) => {
        return state.isDefault
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getFinancialBillMgtList ( {commit} ) {
        return new Promise((resolve, reject) => {
            commit(types.set_loading, true);
            apiGetFinancialBill()
            .then(res => {
                console.log(res)
                commit(types.set_loading, false);
                if( res.data.status == "SUCCESS" ){
                    console.log(res)
                    commit(types.set_financial_bill_list, res.data.result);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    setFinancialBillFilterQuery ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
    setFinancialBillFilterWord ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_word, value);
            resolve()
        })
    },
    setFinancialBillFilterResultTotal ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_result_total, value);
            resolve()
        })
    },
    setFinancialBillFilterDefault ( {commit} ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_default);
            resolve()
        })
    },
    // setHouseMgtMode ( {commit}, data ) {
    //     return new Promise((resolve, reject) => {
    //         commit(types.set_mode, data);
    //         resolve()
    //     })
    // }
}

// mutations
const mutations = {
    [types.set_financial_bill_list](state, data){
        state.financialBillList = data
    },
    [types.set_mode](state, data){
        state.mode = data
    },
    [types.set_filter_word](state, data){
        state.filterWord = data
        state.isDefault = false
    },
    [types.set_filter_query](state, data){
        state.filterQuery = data
        state.isDefault = false
    },
    [types.set_filter_result_total](state, data){
        if(data.type == 'ALL'){
            state.filterTotal.all = data.count
        }else if (data.type == 'OVERDUE'){
            state.filterTotal.overdue = data.count
        }else if (data.type == 'COMPLETELY_PAID'){
            state.filterTotal.paid = data.count
        }else if (data.type == 'UNPAID'){
            state.filterTotal.unpaid = data.count
        }
    },
    [types.set_filter_default](state){
        state.filterQuery.houseName = null
        state.filterQuery.type = null
        state.filterQuery.amount = [0, 100000]
        state.filterQuery.date= null
        state.filterWord = null
        setTimeout(()=>{
            state.isDefault = true
        },100)
    },
    [types.set_loading](state, data){
        state.isLoading = data
    }
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/landlord/financialBill.js